// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__bJGvq","validationTips":"StatementDescriptor_validationTips__3fwhn"};